export default __webpack_public_path__ + "static/media/orderMgmt.4ee734a7.png";